import { render, staticRenderFns } from "./Facturacion.vue?vue&type=template&id=4f912581&scoped=true"
import script from "./Facturacion.vue?vue&type=script&lang=js"
export * from "./Facturacion.vue?vue&type=script&lang=js"
import style0 from "./Facturacion.vue?vue&type=style&index=0&id=4f912581&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f912581",
  null
  
)

export default component.exports